module.exports = __webpack_public_path__ + "img/icon-point.05a39600.png";